module.exports = __webpack_public_path__ + "img/prdays-logo-black.5c679e5b.svg";